import { IconButton, TableCell, TableRow } from "@material-ui/core";
import { AssignmentOutlined } from "@material-ui/icons";
import { useHistory } from "react-router-dom";
import { ReactNode } from "react";
import { Client } from "../../Types/ClientManagement";
import { useStyles } from "./BaseClientTableCell";

export default function ABTestingTableCell({
  columns,
  element,
  index,
}: {
  columns: TableColumn[];
  element: Client;
  index: number;
}) {
  const classes = useStyles();
  const history = useHistory();

  return (
    <TableRow
      className={index % 2 ? classes.rowCell : classes.rowCellOdd}
      key={index}
      onClick={() => {
        history.push({
          pathname: `/abtesting/${element.centralClientId}`,
          state: { client: element },
        });
      }}
      data-test="ab-testing-table-row"
    >
      {columns.map((column, elementIndex) => (
        <TableCell align="left" key={elementIndex}>
          {column.propName === "" ? (
            <IconButton
              style={{
                border: "2px solid rgba(0,0,0,0.3)",
              }}
            >
              <AssignmentOutlined />
            </IconButton>
          ) : (
            (element as unknown as Record<string, ReactNode>)[column.propName]
          )}
        </TableCell>
      ))}
    </TableRow>
  );
}
